module.exports = __webpack_public_path__ + "static/media/Cafe_6.52f600ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/cafe/Cafe_6.png
// module id = 1324
// module chunks = 3